import React from "react";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

const PercentChange = ({ percent }) => {
  if (percent === null || percent === undefined || isNaN(percent)) {
    return (
      <div className="percent-badge neutral">
        <Minus size={12} />
        <span>-</span>
      </div>
    );
  }

  const isPositive = percent >= 0;
  const formatted = Math.abs(percent).toFixed(1) + "%";

  return (
    <div className={`percent-badge ${isPositive ? "positive" : "negative"}`}>
      {isPositive ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
      <span>{formatted}</span>
    </div>
  );
};

export default PercentChange;
